module.exports = __webpack_public_path__ + "img/durability_test.4e57d887.jpg";